<template>
  <div id="jobDetails">
    <div class="detail_container">
      <div class="detail_title_info">
        <div class="job_info">
          <el-input v-model="item.position_name"></el-input>
        </div>
        <div class="base_info">
          <div class="city">
            <img
              src="../../../assets/hr/education_icon.png"
              alt=""
              class="base_info_icon"
            />
            <div>
              <el-select v-model="item.education" @change="changeEducation">
                <el-option
                  v-for="item in educationList"
                  :key="item"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="year">
            <img
              src="../../../assets/hr/year_icon.png"
              alt=""
              class="base_info_icon"
            />
            <div>
              <el-select
                v-model="item.work_experience"
                @change="changeWorkExperience"
              >
                <el-option
                  v-for="item in workExperienceList"
                  :key="item"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="education">
            <img
              src="../../../assets/hr/city_icon.png"
              alt=""
              class="base_info_icon"
            />
            <div><el-input v-model="item.work_addr"></el-input></div>
          </div>
        </div>
        <div class="arrive_time_info">
          到岗时间：
          <el-date-picker
            v-model="item.duty_time"
            type="datetime"
            placeholder="选择日期时间"
            style="left: 20px"
            @change="changeTime"
          >
          </el-date-picker>
        </div>
      </div>
      <div class="detail_content_info">
        <div class="job_detail_info">
          <div class="content_title_info">
            <div class="title_icon"></div>
            <div class="title_text">岗位职责</div>
          </div>
          <div class="detail_text_info">
            <!-- <div v-for="(text, index) in position_statement_list" :key="index">{{ text }}</div> -->
            <el-input
              autosize
              type="textarea"
              v-model="position_statement_list"
              @change="changePosition"
            ></el-input>
          </div>
        </div>
        <div class="job_detail_info">
          <div class="content_title_info">
            <div class="title_icon"></div>
            <div class="title_text">岗位要求</div>
          </div>
          <div class="detail_text_info">
            <el-input
              autosize
              type="textarea"
              v-model="job_requirements_list"
              @change="changeJob"
            ></el-input>
          </div>
        </div>
      </div>
      <div class="detail_recruit_info">
        <el-form
          ref="form"
          :model="form"
          label-width="90px"
          label-position="left"
        >
          <el-form-item label="薪资范围：">
            <div class="box_delete">
              <div
                v-if="
                  (!form.pay_min ||
                    !form.pay_max ||
                    form.pay_min == 'null' ||
                    form.pay_max == 'null') &&
                  !flagDelete
                "
                class="recruit_type"
              >
                薪资面议
              </div>
              <div v-else class="salary_container">
                <el-input
                  v-model="form.pay_min"
                  placeholder="最低薪资"
                  type="number"
                ></el-input>
                <div class="separator">-</div>
                <el-input
                  v-model="form.pay_max"
                  placeholder="最高薪资"
                  type="number"
                ></el-input>
              </div>
              <i class="el-icon-circle-close" @click="setDelete"></i>
            </div>
            <!-- <el-input v-model="form.bonus" placeholder="若不输入薪资范围则默认为面议"></el-input> -->
          </el-form-item>
          <el-form-item label="奖励金额：">
            <el-input
              v-model="form.bonus"
              placeholder="请输入该岗位内推奖励金额"
            ></el-input>
          </el-form-item>
          <el-form-item label="招聘类型：">
            <!-- <div class="recruit_type">{{ item.job_type }}</div> -->
            <el-select
              v-model="item.job_type"
              multiple
              placeholder="请选择"
              @change="changeJobType"
            >
              <el-option
                v-for="item in jobList"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否急招：">
            <el-radio v-model="form.radio" label="1">是</el-radio>
            <el-radio v-model="form.radio" label="0">否</el-radio>
          </el-form-item>
          <el-form-item label="备注：">
            <el-input
              v-model="form.remark"
              placeholder="请输入该岗位备注"
            ></el-input>
          </el-form-item>
          <el-form-item v-if="item.state != 2 && item.relevance_hr_empno == empNo" label="转交：">
            <el-select
              v-model="form.transmit"
              placeholder="请选择"
              @change="changeTransmit"
            >
              <el-option
                v-for="item in optionTransmit"
                :key="item.empno"
                :label="item.empname"
                :value="item.empno"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="item.state != 2" label="共享：">
            <el-select
              v-model="form.share"
              placeholder="请选择"
              @change="changeShare"
              multiple
              collapse-tags
            >
              <el-option
                v-for="item in optionShare"
                :key="item.empno"
                :label="item.empname"
                :value="item.empno"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="btn_container">
        <el-button v-if="item.state == 1" @click="confirmAndReleaseEdit"
          >确认修改</el-button
        >
        <el-button v-else @click="getback">返回</el-button>

        <el-button
          type="danger"
          v-if="item.state == 1"
          @click="confirmAndRelease"
          >下架职位</el-button
        >
        <el-button type="primary" v-else @click="confirmAndRelease"
          >确认并发布职位</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/apis/inside";
import moment from "moment";
import { getToken } from "@/utils/cookie";

export default {
  data() {
    return {
      item: {},
      position_statement_list: [],
      job_requirements_list: [],
      form: {
        bonus: "",
        pay_min: "",
        pay_max: "",
        pay_range: "",
        radio: "1",
        remark: "",
        transmit: "",
        share: [],
      },
      educationList: ["小学", "初中", "高中", "大专", "本科", "硕士", "博士"],
      workExperienceList: [
        "1年",
        "2年",
        "3年",
        "4年",
        "5年",
        "6年",
        "7年",
        "8年",
        "9年",
        "10年及以上",
      ],
      jobList: ["内部招聘", "外部招聘"],
      optionTransmit: [],
      optionShare: [],
      flagDelete: false,
      empNo: "",
    };
  },
  created() {
    this.initData();
    this.getOption();
    this.empNo = getToken();
  },
  methods: {
    // 获取转交和共享
    getOption() {
      api.HrDisplay().then((data) => {
        console.log(data, "data");
        this.optionTransmit = data.hrInfo;
        this.optionShare = data.hrInfo;
      });
    },
    // 获取岗位详情
    initData() {
      const info = JSON.parse(this.$route.query.item);
      this.item = info;
      console.log(this.item, "item");
      this.item.work_experience = this.item.work_experience.includes("年")
        ? this.item.work_experience
        : this.item.work_experience + "年";
      this.item.job_type = this.item.job_type.split("|");
      this.form.transmit = this.item.type1;
      this.form.share = this.item.type2 && this.item.type2.split(',');
      this.form.bonus = this.item.bonus;
      this.form.remark = this.item.remark;
      this.form.pay_min = this.item.pay_min == 0 ? "" : this.item.pay_min;
      this.form.pay_max = this.item.pay_max == 0 ? "" : this.item.pay_max;
      this.form.pay_range = this.item.pay_range;
      this.form.radio = this.item.urgency_state == 1 ? "1" : "0";
      this.position_statement_list =
        this.item.position_statement &&
        this.item.position_statement.split("<br>").join("");
      this.job_requirements_list =
        this.item.job_requirements &&
        this.item.job_requirements.split("<br>").join("");
    },
    // 返回
    getback() {
      this.$router.go(-1);
    },
    setDelete() {
      if (this.flagDelete) {
        this.flagDelete = false;
      } else {
        this.flagDelete = true;
      }
      // this.flagDelete != this.flagDelete;
    },
    //选择转交
    changeTransmit(value) {
      console.log(value);
      this.form.transmit = value;
    },
    //选择共享：
    changeShare(value) {
      console.log(value);
      this.form.share = value;
    },
    //选择学历
    changeEducation(value) {
      this.item.education = value;
    },
    //选择工作经验
    changeWorkExperience(value) {
      this.item.work_experience = value;
    },
    //选择时间
    changeTime(value) {
      this.item.duty_time = moment(value).format("YYYY-MM-DD HH:mm:ss");
    },
    //岗位职责
    changePosition(value) {
      this.item.position_statement = value;
    },
    //岗位要求
    changeJob(value) {
      this.item.job_requirements = value;
    },
    //岗位类型
    changeJobType(value) {
      this.item.job_type = value;
    },
    //确认修改
    confirmAndReleaseEdit() {
      const pay_range = this.form.pay_min + "-" + this.form.pay_max;
      api
        .PostSave({
          id: this.item.id,
          comfirm: true, // 确定字段：为true时，修改
          bonus: this.form.bonus, // 内推分红奖励,（必填，可为空）
          pay_range: pay_range, // 薪资范围：中间用“-”,（必填，可为空）隔开
          urgency_state: this.form.radio, // 紧急标签是否显示，0：不显示，1：显示（必填，可为空）
          position_name: this.item.position_name, //岗位名称
          work_experience: this.item.work_experience, //工作经验
          education: this.item.education, //学历
          work_addr: this.item.work_addr, //工作地点
          orgName: "", //部门名称，暂不使用
          position_statement: this.item.position_statement, //工作内容
          job_requirements: this.item.job_requirements, //工作要求
          duty_time: this.item.duty_time, //到岗时间
          job_type: this.item.job_type.join("|"), //招聘类型
          remark: this.form.remark,
          type1: this.form.transmit, // 转交
          type2: this.form.share.join(","), // 共享
        })
        .then((res) => {
          if (res.code == 200) {
            this.$message({
              message: "修改成功",
              type: "success",
            });
            this.getback();
          }
        });
    },
    //确认并发布职位
    confirmAndRelease() {
      const pay_range = this.form.pay_min + "-" + this.form.pay_max;
      console.log(this.form.share,'this.form.share');
      api
        .PostRevise({
          //该接口用于单个岗位信息的修改
          state: this.item.state,
          id: this.item.id,
          bonus: this.form.bonus, // 内推分红奖励,（必填，可为空）
          pay_range: pay_range, // 薪资范围：中间用“-”,（必填，可为空）隔开
          urgency_state: this.form.radio, // 紧急标签是否显示，0：不显示，1：显示（必填，可为空）
          position_name: this.item.position_name,
          work_experience: this.item.work_experience,
          education: this.item.education,
          work_addr: this.item.work_addr,
          orgName: "",
          position_statement: this.item.position_statement,
          job_requirements: this.item.job_requirements,
          duty_time: this.item.duty_time,
          job_type: this.item.job_type.join("|"),
          remark: this.form.remark,
          type1: this.form.transmit, // 转交
          type2: this.form.share && this.form.share.join(","), // 共享
        })
        .then((res) => {
          if (res.code == 200) {
            this.getback();
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  #jobDetails {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  #jobDetails {
    width: 276px * $zoom;
  }
}
#jobDetails {
  font-size: 16px * $zoom;
  position: relative;
  .detail_container {
    width: 100%;
    min-height: 100vh;
    padding-bottom: 136px;
    background: #f7f9fa;
    .detail_title_info {
      padding: 36px 32px;
      background: #fff;
      .job_info {
        font-size: 36px;
        font-weight: bold;
        color: #282b32;
      }
      .base_info {
        overflow: hidden;
        margin-top: 40px;
        color: #969b9e;
        font-size: 28px;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: space-between;
        & > div {
          float: left;
          padding-right: 28px;
        }
        .city {
          display: flex;
          align-items: center;
          .base_info_icon {
            width: 36px;
            height: 30px;
            margin-right: 12px;
          }
        }
        .year {
          display: flex;
          align-items: center;
          .base_info_icon {
            width: 28px;
            height: 28px;
            margin-right: 12px;
          }
        }
        .education {
          display: flex;
          align-items: center;
          padding-right: 0;
          .base_info_icon {
            width: 26px;
            height: 32px;
            margin-right: 12px;
          }
        }
      }
      .arrive_time_info {
        margin-top: 40px;
        color: #666666;
        font-size: 28px;
        display: flex;
        align-items: center;
      }
    }
    .detail_content_info {
      margin-top: 24px;
      padding: 0 32px 32px;
      background: #fff;
      .content_title_info {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding-top: 40px;
        .title_icon {
          width: 8px;
          height: 32px;
          margin-right: 20px;
          background: #4ea27c;
          border-radius: 4px;
        }
        .title_text {
          font-size: 32px;
          font-weight: bold;
          color: #282b32;
        }
      }
      .detail_text_info {
        text-overflow: ellipsis;
        margin-top: 20px;
        color: #666666;
        font-size: 30px;
        line-height: 56px;
      }
    }
    .detail_recruit_info {
      margin-top: 24px;
      padding: 32px;
      background: #fff;
      ::v-deep .el-form {
        .el-form-item {
          &:last-child {
            margin: 0;
          }
          .el-form-item__label {
            padding: 0;
            font-size: 30px;
            line-height: 64px;
            color: #666666;
            text-align: right;
          }
          .el-form-item__content {
            line-height: 64px;
            .recruit_type {
              font-size: 30px;
              color: #282b32;
            }
            .el-input {
              .el-input__inner {
                height: 64px;
                font-size: 30px;
                background: #ffffff;
                border-radius: 4px;
                border: 1rpx solid #c1c1c1;
                &::placeholder {
                  font-size: 30px;
                  color: #b5b5b5;
                }
              }
            }
            .salary_container {
              display: flex;
              .separator {
                margin: 0 20px;
              }
            }
            .el-radio {
              .el-radio__label {
                color: #969b9e;
              }
              .is-checked {
                .el-radio__inner {
                  background: #4ea27c;
                }
                .el-radio__label {
                  color: #282b32;
                }
              }
            }
          }
        }
      }
      .box_delete {
        display: flex;
        align-items: center;
        i {
          margin-left: 10px * $zoom;
          font-size: 12px * $zoom;
        }
      }
      .choose_depament {
        border: 1px solid #dcdfe6;
        padding-left: 10px * $zoom;
      }
    }
    .btn_container {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 96px;
      background: #eee;
      .el-button {
        width: 35%;
        height: 100%;
        border: none;
        font-size: 30px;
        color: #282b32;
        border-radius: 0;
      }
      .el-button--primary {
        width: 65%;
        margin: 0;
        background: #4ea27c;
        color: #ffffff;
      }
      .el-button--danger {
        width: 65%;
        margin: 0;
        background: #e22121;
        color: #ffffff;
      }
    }
  }
}

::v-deep {
  .el-input__inner {
    height: 26px * $zoom;
    font-size: 10px * $zoom;
  }
  .el-date-editor {
    left: 0 !important;
    // width: 78%;
    flex: 1;
  }
  .el-textarea__inner {
    font-size: 10px * $zoom;
  }
  .el-select {
    width: 100%;
  }
  // .detail_text_info {
  //   .el-input__inner {
  //     height: none !important;
  //     font-size: 10px * $zoom;
  //   }
  // }
}
</style>
<style lang="scss">
.el-picker-panel {
  left: 80px * $zoom !important;
}
</style>
